import { render, staticRenderFns } from "./summaryStatsCard.vue?vue&type=template&id=6492fe11&scoped=true"
import script from "./summaryStatsCard.vue?vue&type=script&lang=js"
export * from "./summaryStatsCard.vue?vue&type=script&lang=js"
import style0 from "./summaryStatsCard.vue?vue&type=style&index=0&id=6492fe11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6492fe11",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QBtn});
